<template>
  <div class="locale-changer">
    <b-form-select v-model="$i18n.locale" :options="options"></b-form-select>
  </div>
</template>

<script>
export default {
  name: 'locale-changer',
  data () {
    return {
      options: [
        { value: 'en', text: this.$i18n.t('English') },
        { value: 'ru', text: this.$i18n.t('Russian') }
      ]
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/langSwitcher.vue